import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { WebClientDetailFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientDetailFetcher';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import { FieldValuesQuery } from '../../httpClient/resources/FieldValuesQuery';
import { IActionResource, IDetailResource, IFieldValuesResource, IListResource } from '../../httpClient/resources/Resource';
import { ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { GetFieldValuesRequest } from '../../httpClient/serverApi/requests/GetFieldValuesRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { ILensDetailInfo, ILensInfo } from '../models/ILensInfo';
import { LensMapper } from '../models/mappers/LensMapper';
import { DeleteLensesRequest } from '../serverApi/requests/DeleteLensesRequest';
import { GetLensActionsRequest } from '../serverApi/requests/GetLensActionsRequest';
import { GetLensesRequest } from '../serverApi/requests/GetLensesRequest';
import { MoveLensesToProjectRequest } from '../serverApi/requests/MoveLensesToProjectRequest';
import { SetLensesOwnerRequest } from '../serverApi/requests/SetLensesOwnerRequest';
import { ILensActions } from '../serverApi/types/ILensAction';

export class LensesResource implements IListResource<ILensInfo>, IFieldValuesResource, IDetailResource<ILensDetailInfo>, IActionResource<ILensActions> {

  private listFetcher = new WebClientListResourceFetcher(GetLensesRequest, ServerApiMapper.lenses);
  private detailFetcher = new WebClientDetailFetcher('getLens', LensMapper.mapDetail);
  private fieldValuesFetcher = new WebClientListResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);

  public all(): ResourceQuery<ILensInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public getById(id: string): Promise<ILensDetailInfo> {
    return this.detailFetcher.fetchById(id);
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'lens');
  }

  // Actions
  public actions(id: string): Promise<ILensActions> {
    return WebHttpClient.sendRequest(new GetLensActionsRequest(id));
  }

  public deleteLenses(ids: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteLensesRequest(idsBlock)),
      ResultHelper.combineResults
    );
  }

  public setOwner(ids: string[], ownerId: string): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetLensesOwnerRequest(idsBlock, ownerId)),
      ResultHelper.combineResults);
  }

  public moveToProject(targetProjectId: string, lensIds: string[]): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequestsAndDelay(
      RequestHelper.buildRequests(lensIds, (idsBlock) => new MoveLensesToProjectRequest({
        ids: idsBlock,
        projectId: targetProjectId
      })),
      ResultHelper.combineResults);
  }
}

export const Lenses = new LensesResource();
